import { BreadcrumbsSkeleton } from '../Breadcrumbs';
import { ButtonSkeleton } from '../Button';
import { Skeleton } from '../Skeleton';
import { HeaderActionsSeparator } from './HeaderBar';

/**
 * Skeleton for the header bar.
 */
export function HeaderBarSkeleton() {
    return (
        <>
            <HeaderBarOneRowSkeleton />
            <HeaderBarTwoRowsSkeleton />
        </>
    );
}

/**
 * Skeleton for the single row header bar displayed on large screens.
 */
export function HeaderBarOneRowSkeleton() {
    return (
        <header className="h-toolbar-header items-center justify-between gap-4 border-b px-6 max-xl:hidden xl:flex">
            <BreadcrumbsSkeleton items={2} />
            <div className="flex">
                <ButtonSkeleton className="max-w-6 md:max-w-full" label="Other options" />
                <ButtonSkeleton className="max-w-6 md:max-w-full" label="Space actions" />
            </div>
        </header>
    );
}

/**
 * Skeleton for the 2-rows header bar displayed on medium and small screens.
 */
export function HeaderBarTwoRowsSkeleton() {
    return (
        <header className="xl:hidden">
            <div className="flex h-toolbar-header items-center gap-2 border-b px-6">
                <Skeleton shape="rect" className="size-6" />
                <BreadcrumbsSkeleton items={1} />
            </div>
            <div className="flex h-toolbar-header items-center justify-between gap-4 border-b px-6">
                <div className="flex items-center gap-2">
                    <ButtonSkeleton iconOnly label="Set up Git Sync" className="size-8" />
                    <ButtonSkeleton iconOnly label="Share" className="size-8" />
                    <ButtonSkeleton
                        iconOnly
                        label="Integrations"
                        className="hidden size-8 md:block"
                    />
                    <HeaderActionsSeparator />
                    <ButtonSkeleton iconOnly label="Comments" className="hidden size-8 md:block" />
                    <ButtonSkeleton iconOnly label="Audits" className="hidden size-8 md:block" />
                    <ButtonSkeleton
                        iconOnly
                        label="Version history"
                        className="hidden size-8 md:block"
                    />
                </div>
                <div className="flex items-center gap-2">
                    <ButtonSkeleton label="Change requests" className="w-11 md:w-40 " />
                    <ButtonSkeleton label="Edit" className="w-28" />
                </div>
            </div>
        </header>
    );
}
